import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';
import { EmployeeSalary } from '../../personnel-setup/hr-employee-extracted-salary/hr-employee-extracted-salary.service';
import { BankExpensesStpTrans } from '../bank-expenses-stp-trans/bank-expenses-stp-trans.service';

let BankTransformerUrl = CONFIG.baseUrls.BankTransformer;
export interface BankTransformer {
    serial: number;
    transType: number;
    isEmployeeLoans?: number;
    transformerType: number;
    transFromCode: number;
    transToCode: number;
    transDate: Date;
    transDateTo: Date;
    transDateFrom: Date;
    value: number;
    transStatus: number;
    collectedJour: number;
    currency: number;
    currencyFactor?: number;
    bankCode: number,
    payedValue?: number,
    remainingValue?: number,
    remainingBefore?: number,
    glJournalFlag?: number,
    editBankFlag?: number,
    notes: string,
    referenceNumber: number,
    benefCode: number,
    costCenterCode: number,
    beneficeryAr: string,
    beneficeryEn: string,
    costCenterAr: string,
    costCenterEn: string,
    settlementType: number,
    companyCode?: number;
    confirmedStatus?: number;
    settlement: number,
    glJournalCode: number,
    supplierCode: number,
    accountNo: number,
    empCode: number,
    dataStatus?: number;
    transferVat?: number;
    transferExpenses?: number;
    constraintMoved?: number;
    cCCallBeneficiarySerial?: number;
    transferOnlineFlag?: number;
    bankExpensesStpCode1?: number;
    bankExpensesStpCode2?: number;
    reverseTransFerBankSerial?: number;
    reverseTransFerBankFlag?: number;

}
export interface cshBankTransformerLog {
    serial: number;
    cshCashierTransSerial: number;
    bankTransformerSerial?: number;
    transDate?: Date;
    value?: number;
    payedValue?: number,
    remainingValue?: number
    Type?: number
    regDate?: Date
    transType?: number;
    transTypeAr?: string;
    settleValue?: number;
    editValue?: number;
    logicType?: number;
}

export interface SalaryBankTransform {
    bankTransformer: BankTransformer[];
    employeeSalary: EmployeeSalary[];

}


export interface BankTransformerAndBankExpensesStpTrans {
    BankTransformer: BankTransformer;
    BankExpensesStpTrans: BankExpensesStpTrans;

}
@Injectable()
export class BankTransformerService {
    constructor(private httpGeneralService: HttpGeneralService) { }

    getBankTransformer(id: number) {
        return this.httpGeneralService.get(id, BankTransformerUrl);
    }
    getBankTransformerwithType(id: number, type: number) {
        return this.httpGeneralService.getWith(`${BankTransformerUrl}/${id}/${type}`);
    }
    getBankTransformerLoad(BankTransformer: BankTransformer) {
        return this.httpGeneralService.add(BankTransformer, `${BankTransformerUrl}/getBankTransformerLoad`);
    }
    addBankTransformer(BankTransformer: BankTransformer) {
        return this.httpGeneralService.add<BankTransformer>(BankTransformer, BankTransformerUrl);
    }
    updatebankTransformerAndBankExpensesStpTrans(bankTransformerAndBankExpensesStpTrans: BankTransformerAndBankExpensesStpTrans) {
        return this.httpGeneralService.add<BankTransformerAndBankExpensesStpTrans>(bankTransformerAndBankExpensesStpTrans, `${BankTransformerUrl}/updatebankTransformerAndBankExpensesStpTrans`);
    }

    updateBankTransformer(BankTransformer: BankTransformer) {
        return this.httpGeneralService.update<BankTransformer>(BankTransformer.serial, BankTransformer, BankTransformerUrl);
    }
    editBankInBankTransformer(BankTransformer: BankTransformer) {
        return this.httpGeneralService.add<BankTransformer>( BankTransformer, `${BankTransformerUrl}/EditBankInBankTransformer`);
    }


    updateBankTransformerConfirmed(BankTransformer: BankTransformer) {
        return this.httpGeneralService.update<BankTransformer>(BankTransformer.serial, BankTransformer, `${BankTransformerUrl}/updateBankTransformerConfirmed`);
    }


    deleteBankTransformer(BankTransformer: BankTransformer) {
        return this.httpGeneralService.delete<number>(BankTransformer.serial, BankTransformerUrl);
    }
    addsalaryBankTransform(salaryBankTransform: SalaryBankTransform) {
        return this.httpGeneralService.add<SalaryBankTransform>(salaryBankTransform, `${BankTransformerUrl}/addsalaryBankTransform`);
    }
    getCshCurrency(cshCurrency: any) {
        return this.httpGeneralService.add(cshCurrency, `${BankTransformerUrl}/getCshCurrency`)

    }

    getBankExpensesStpWithBankTransformerSerial(BankExpensesStpTrans: BankExpensesStpTrans) {
        return this.httpGeneralService.add(BankExpensesStpTrans, `${BankTransformerUrl}/getBankExpensesStpWithBankTransformerSerial`)

    }

    addBankTransformerList(bankTransformer: BankTransformer[]) {
        return this.httpGeneralService.addCollection(bankTransformer, `${BankTransformerUrl}/addBankTransformerList`)
    }
}
